(ns app.front.view.inspections.time-tracking
  (:require [app.front.ui :as ui]
            [app.front.util :as futil]
            [re-frame.core-instrumented :as rf]))


(rf/reg-sub ::enabled?
  :<- [:app.front.view.workspace.subs/group-features]
  :<- [:session/user]
  (fn [[group-features user] _]
    (and (:user/authority? user)
         (-> group-features :inspection-time-tracking? boolean))))


(defn time-tracking [{:keys [tr value on-change on-blur]}]
  [ui/number-input {:id         "time-tracking-minutes"
                    :label-text (tr [:inspection.visit/time-spent])
                    :required   true
                    :min        0
                    :value      value
                    :step       15
                    :on-blur    (when on-blur
                                  (fn [e] (-> e futil/tval futil/parse-int on-blur)))
                    :on-change  (when on-change
                                  (fn [e] (-> e futil/tval futil/parse-int on-change)))}])
